import {
  RouterProvider,
  createBrowserRouter,
  useNavigate,
} from "react-router-dom";
import ThemeCustomization from "./themes";
import ScrollTop from "./components/ScrollTop";
import { ToastContainer } from "react-toastify";
import { bounce } from "./pages/TosterAlert";
import axios from "axios";
import { getCookie } from "./helpers/cookie";
import { handleAuthentication, resetDataAndLogout } from "./helpers/auth";
import LoginRoutes from "./routes/LoginRoutes";
import MainRoutes from "./routes/MainRoutes";
import { useSelector } from "react-redux";
import "./App.css";
import { useEffect } from "react";
import SessionManager from "./auth/SessionManager";




const skipAuthRoutes = [
  "login",
  "refreshToken",
  "OTPValidation",
  "registration",
  "registerLogin",
];
const skipEmpanelRegistration = ["OTPValidation", "registration","/registration/existingRegistration"];

axios.interceptors.request.use(
  function (config) {
    const skipCheckRegister = skipEmpanelRegistration.some((route) =>
      config.url.includes(route)
    );

    const skipCheck = skipAuthRoutes.some((route) =>
      config.url.includes(route)
    );

    const path = window.location.pathname;
    const regPaths = ["/registration", "/registration/existingRegistration"];

    if (!skipCheck && !regPaths.includes(path)) {
      config.headers.Authorization = `Bearer ${getCookie("accessToken")}`;
    } else if (!skipCheck && regPaths.includes(path)) {
      config.headers.Authorization = `Bearer ${getCookie("registerNewAccessToken")}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error?.response?.status === 401) {
      if (error?.config?.url.includes("refreshToken")) {
        resetDataAndLogout();
        window.location.href = "/";
        return Promise.reject(error);
      }
      return handleAuthentication(error);
    }
    return Promise.reject(error);
  }
);

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const login = useSelector((state) => state?.login || []);

  const isLogggedIn = getCookie("accessToken");

  const routes = [LoginRoutes];

  if (isLogggedIn || login) {
    routes.push(MainRoutes);
  }

  // ==============================|| DISABLE DEVELOPER TOOLS ||============================== //
  // NOTE: DevTools detection (window-size based) is handled in public/index.html.
  // This useEffect only blocks right-click and keyboard shortcuts as a secondary layer.
  // Both are guarded by REACT_APP_ENV so local/dev mode is never affected.
  useEffect(() => {
    // Skip ALL restrictions in local / development mode
    // REACT_APP_ENV is set via .env.development (local) or .env.production (production)
    if (process.env.REACT_APP_ENV !== "production") return;

    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    // Block DevTools keyboard shortcuts
    const handleKeyDown = (e) => {
      // F12
      if (e.key === "F12" || e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I / Ctrl+Shift+J / Ctrl+Shift+C (Chrome DevTools)
      if (
        e.ctrlKey &&
        e.shiftKey &&
        (e.key === "I" || e.key === "i" ||
          e.key === "J" || e.key === "j" ||
          e.key === "C" || e.key === "c")
      ) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (View Source)
      if (e.ctrlKey && (e.key === "U" || e.key === "u")) {
        e.preventDefault();
        return false;
      }
      // Ctrl+S (Save page)
      if (e.ctrlKey && (e.key === "S" || e.key === "s")) {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);


const router = createBrowserRouter(routes, {
  basename: "/",
  future: {
   v7_startTransition: true,
  }
});


  return (
    <ThemeCustomization>
      <ScrollTop>
        <ToastContainer transition={bounce} />
        {/* <SessionTimeoutHandler /> */}
        <SessionManager children={  <RouterProvider router={router} />}
        
        />
      </ScrollTop>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          input[type="password"]::-ms-reveal,
          input[type="password"]::-ms-clear {
            display: none !important;
          }
        `,
        }}
      />
    </ThemeCustomization>
  );
}
